import React, { useEffect, useState } from 'react';
import ImgDefault from '@core/ui/static/images/user-cover-default.jpg';
import { CoverImageImg, CoverImageWrapper } from './cover-image.style';
import { useTranslation } from 'next-i18next';

const CoverImage = props => {
  const { t } = useTranslation();

  const { image = false } = props;
  const [img, setImg] = useState(ImgDefault);

  useEffect(() => {
    if (image) {
      setImg(image);
    } else {
      setImg(ImgDefault);
    }
  });

  return (
    <CoverImageWrapper>
      <CoverImageImg src={img} alt={t('user.coverImgDesc')} />
    </CoverImageWrapper>
  );
};

export default CoverImage;
